/**
 * product-reviews.js — sorting, star filtering and show-more for the review
 * list rendered by snippets/product-reviews.liquid.
 *
 * Every review is already in the DOM, so none of this touches the network.
 * Okendo's widget re-fetched from its API on each sort; this reorders nodes.
 *
 * The list is fully usable with JS disabled: all reviews are real markup, and
 * the controls simply do nothing.
 */
(function () {
  'use strict';

  function init(root) {
    var list = root.querySelector('[data-mi-list]');
    if (!list) return;

    var items = Array.prototype.slice.call(list.querySelectorAll('[data-mi-review]'));
    if (!items.length) return;

    var moreBtn = root.querySelector('[data-mi-more]');
    var sortSel = root.querySelector('[data-mi-sort]');
    var empty = root.querySelector('[data-mi-empty]');
    var activeBox = root.querySelector('[data-mi-active]');
    var activeText = root.querySelector('[data-mi-active-text]');
    var clearBtn = root.querySelector('[data-mi-clear]');

    var PAGE = 8;
    var shown = PAGE;
    var filter = 0; // 0 = all

    var num = function (el, attr) {
      return parseFloat(el.getAttribute(attr)) || 0;
    };

    function matching() {
      return filter
        ? items.filter(function (el) { return Math.round(num(el, 'data-rating')) === filter; })
        : items;
    }

    function render() {
      var visible = matching();

      items.forEach(function (el) { el.hidden = true; });
      visible.slice(0, shown).forEach(function (el) { el.hidden = false; });

      if (empty) empty.hidden = visible.length !== 0;
      if (moreBtn) moreBtn.hidden = visible.length <= shown;

      if (activeBox) {
        activeBox.hidden = !filter;
        if (filter && activeText) {
          activeText.textContent =
            'Showing ' + visible.length + ' review' + (visible.length === 1 ? '' : 's') +
            ' rated ' + filter + ' star' + (filter === 1 ? '' : 's');
        }
      }

      root.querySelectorAll('[data-mi-filter]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(Number(b.getAttribute('data-mi-filter')) === filter));
      });
    }

    function sortBy(mode) {
      // Ties break on date, newest first. Without it, equal ratings came back
      // in whatever order the previous sort happened to leave them.
      var byDate = function (a, b) { return num(b, 'data-date') - num(a, 'data-date'); };
      var cmp = {
        recent:  byDate,
        helpful: function (a, b) { return num(b, 'data-helpful') - num(a, 'data-helpful') || byDate(a, b); },
        highest: function (a, b) { return num(b, 'data-rating') - num(a, 'data-rating') || byDate(a, b); },
        lowest:  function (a, b) { return num(a, 'data-rating') - num(b, 'data-rating') || byDate(a, b); }
      }[mode];
      if (!cmp) return;
      items.sort(cmp);
      // One reflow rather than one per node.
      var frag = document.createDocumentFragment();
      items.forEach(function (el) { frag.appendChild(el); });
      list.appendChild(frag);
    }

    if (sortSel) {
      sortSel.addEventListener('change', function () {
        sortBy(sortSel.value);
        shown = PAGE;
        render();
      });
    }

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        shown += PAGE;
        render();
        // Move focus to the first newly revealed review so keyboard and screen
        // reader users are not dropped back at the top of the list.
        var next = matching()[shown - PAGE];
        if (next) {
          next.setAttribute('tabindex', '-1');
          next.focus({ preventScroll: true });
        }
      });
    }

    root.querySelectorAll('[data-mi-filter]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var star = Number(btn.getAttribute('data-mi-filter'));
        filter = filter === star ? 0 : star;
        shown = PAGE;
        render();
      });
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        filter = 0;
        shown = PAGE;
        render();
      });
    }

    // The markup is already highest-first, but Liquid cannot settle ties, so
    // the default sort is applied once on load.
    if (sortSel) sortBy(sortSel.value);
    render();
  }

  function boot() {
    document.querySelectorAll('[data-mi-reviews]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
